export default function normalizeGuestName(
  firstName?: string | null,
  lastName?: string | null
) {
  const cleanFirstName = firstName?.trim();
  const cleanLastName = lastName?.trim();
  const isValidNamePart = (name?: string | null) =>
    !!name && name.toLowerCase() !== "null" && name.toLowerCase() !== "undefined";

  const hasFirstName = isValidNamePart(cleanFirstName);
  const hasLastName = isValidNamePart(cleanLastName);

  if (hasFirstName && hasLastName) {
    return `${cleanFirstName} ${cleanLastName}`;
  }

  if (hasFirstName) {
    return cleanFirstName;
  }

  if (hasLastName) {
    return cleanLastName;
  }

  return "Guest";
}
